var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "durations" }, [
    _c(
      "div",
      { staticClass: "available-durations" },
      [
        _vm._l(_vm.purchasableDurations, function(purchasableDuration) {
          return [
            _vm.availableDuration(purchasableDuration)
              ? _c(
                  "div",
                  {
                    key: purchasableDuration,
                    staticClass: "duration",
                    class: { selected: purchasableDuration === _vm.duration },
                    on: {
                      click: function($event) {
                        _vm.selectedDuration(purchasableDuration)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "duration-time" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("durationFilter")(purchasableDuration)
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.initialHour
                      ? _c("span", { staticClass: "range" }, [
                          _vm._v("\n          dàs "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm._f("hourFilter")(_vm.initialHour))
                            )
                          ]),
                          _vm._v(" até às "),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm._f("hourFilter")(
                                  _vm.initialHour + purchasableDuration
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "range" }, [
                      _vm._v("\n          valor "),
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toCurrency")(
                              _vm.pricingWithDiscount(purchasableDuration) ||
                                _vm.pricing(purchasableDuration)
                            )
                          )
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-247e6afc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-247e6afc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalFilters/DurationPicker.vue
// module id = null
// module chunks = 